<template>
  <FormGroup :error-container="errorContainer" label="Number of Dependants" name="numberOfDependents" :floating="floating">
    <FmSelect :value="value" :options="options" :icons="icons" :disabled="disabled"
              @input="$emit('input', $event !== '' ? Number($event) : '')"/>
  </FormGroup>
</template>

<script>
import ServerErrorMixin from '@modules/shared/mixins/ServerErrorMixin';
import FormGroup from '@modules/shared/components/form/FormGroup.vue';
import FmSelect from '@modules/shared/components/form/FmSelect.vue';
import {NumberOfDependentOptions} from '@modules/guest/new-applicant/constants.js';

// Person icon for every dependant count
const ICON = `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4z"/></svg>`;

export default {
  name: 'NumberOfDependentsSelect',
  components: { FormGroup, FmSelect },
  mixins: [ServerErrorMixin],
  model: { prop: 'value', event: 'input' },
  props: {
    value:          { type: [String, Number], default: '' },
    disabled:       { default: false },
    errorContainer: { default: '' },
    floating:       { type: Boolean, default: false },
  },
  computed: {
    options: () => NumberOfDependentOptions,
    icons()  { return Object.fromEntries(NumberOfDependentOptions.map(n => [n, ICON])); },
  },
  watch: {
    errorContainer: {
      immediate: true,
      handler(container) { if (container) this.registerErrorContainer(container); },
    },
  },
};
</script>
